import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { STYLES_NAME } from '../../constants/stylesName/stylesName';
import { useStyles } from '../../hooks/useStyles/useStyles';
import { ErrorBoundary } from '../../provider/errorBoundary/errorBoundary';
import { FallbackComponent } from '../../provider/errorBoundary/fallbackComponent';
import { BreadcrumbsStandAlone } from './breadcrumbsStandAlone';
const BreadcrumbsControlledComponent = React.forwardRef(({ ctv, ...props }, ref) => {
    const styles = useStyles(STYLES_NAME.BREADCRUMB, props.variant, ctv);
    return _jsx(BreadcrumbsStandAlone, { ...props, ref: ref, styles: styles });
});
BreadcrumbsControlledComponent.displayName = 'BreadcrumbsControlledComponent';
const BreadcrumbsBoundary = (props, ref) => (_jsx(ErrorBoundary, { fallBackComponent: _jsx(FallbackComponent, { children: _jsx(BreadcrumbsStandAlone, { ...props, ref: ref, crumbs: [] }) }), children: _jsx(BreadcrumbsControlledComponent, { ...props, ref: ref }) }));
/**
 * @description
 * Breadcrumbs component is a component that shows a breadcrumbs with a message.
 * to show list of links.
 * @param {React.PropsWithChildren<IBreadcrumbsControlled<V>>} props
 * @returns {JSX.Element}
 * @example
 * <BreadcrumbsControlled />
 * <BreadcrumbsControlled variant="primary" />
 */
const BreadcrumbsControlled = React.forwardRef(BreadcrumbsBoundary);
export { BreadcrumbsControlled };
export { BreadcrumbsControlled as Breadcrumbs };
//# sourceMappingURL=breadcrumbsControlled.js.map